import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../components/Layout/PageContainer";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <PageContainer>
      <Stack
        sx={{
          // flex: 1,
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          background: (theme) => theme.palette.background.layout,
        }}
      >
        <Typography variant="h5" align="center" p={5}>
          {t("page_contact.body")}
        </Typography>
      </Stack>
      <Stack
        sx={{
          width: "100%",
          height: { xs: "400px", md: "500px" },
        }}
      >
        <iframe
          style={{ flex: 1, border: 0 }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.2887688882465!2d3.4791534766902896!3d43.28933997112188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b13c8469fe6db3%3A0x71938341e516abfb!2sJardinerie%20Fleuriland!5e1!3m2!1sfr!2sfr!4v1681465250162!5m2!1sfr!2sfr"
          width="100%"
          allowFullScreen={false}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </Stack>
    </PageContainer>
  );
};

export default Contact;
